import React from 'react'

export const SparkleIcon = ({ size = 18, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 3L13.5 8.5L19 10L13.5 11.5L12 17L10.5 11.5L5 10L10.5 8.5L12 3Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinejoin="round"
            fill="none"
        />
        <path
            d="M19 16L19.75 18.25L22 19L19.75 19.75L19 22L18.25 19.75L16 19L18.25 18.25L19 16Z"
            stroke={color}
            strokeWidth="1.2"
            strokeLinejoin="round"
            fill="none"
        />
    </svg>
)

export const MicIcon = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            x="9"
            y="3"
            width="6"
            height="12"
            rx="3"
            stroke={color}
            strokeWidth="1.5"
        />
        <path
            d="M5 11C5 14.866 8.13401 18 12 18C15.866 18 19 14.866 19 11"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <path
            d="M12 18V21"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
)

export const SendArrowIcon = ({ size = 18, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5 12H19M19 12L12 5M19 12L12 19"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const AttachIcon = ({ size = 18, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M21.44 11.05L12.25 20.24C11.1242 21.3658 9.59723 21.9983 8.005 21.9983C6.41277 21.9983 4.88584 21.3658 3.76 20.24C2.63416 19.1142 2.00166 17.5872 2.00166 15.995C2.00166 14.4028 2.63416 12.8758 3.76 11.75L12.95 2.56C13.7006 1.80944 14.7186 1.38777 15.78 1.38777C16.8414 1.38777 17.8594 1.80944 18.61 2.56C19.3606 3.31056 19.7822 4.32856 19.7822 5.39C19.7822 6.45144 19.3606 7.46944 18.61 8.22L9.41 17.41C9.03473 17.7853 8.52573 17.9961 7.995 17.9961C7.46427 17.9961 6.95527 17.7853 6.58 17.41C6.20473 17.0347 5.99389 16.5257 5.99389 15.995C5.99389 15.4643 6.20473 14.9553 6.58 14.58L15.07 6.1"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
